export default {"src":"/_next/static/media/use.e256bb60.svg","height":457,"width":621};